export const WARNING_OFFER_END_DELAY = 30 // Number of days before the end of the subscription to display a warning
